<template>
  <!-- <div class="h-full w-full relative flex justify-between"> -->
  <div class="left w-full h-full p-5px overflow-y-auto">
    <div class="w-full">
      <div class="statisticsNum w-full flex flex-wrap">
        <div
          @click="viewDetail(item)"
          v-for="(item, index) in deviceList"
          :key="index"
          class="flex justify-around items-center w-1/2 cursor-pointer"
        >
          <img :src="item.url" alt="" />
          <div>
            <div>
              <span class="text-20px">{{ item.currenAreaNum }}</span>
              <span>/</span>
              <span>{{ item.totalNum }}</span>
              <span>个</span>
            </div>
            <p>{{ item.name }}</p>
          </div>
        </div>
      </div>
      <div class="statisticsRate flex justify-between mt-10px">
        <div
          v-for="(item, index) in rateList"
          :key="index"
          class="w-31/100 flex flex-col justify-center reteItem"
        >
          <div :class="index === 0 ? 'one' : index === 1 ? 'two' : 'three'">{{ item.name }}</div>
          <div class="bottomBox">
            <div class="flex justify-between items-center h-28px p-8px totalBox">
              <span class="text-12px withe07">总数</span>
              <span>{{ item.totalNum }}</span>
            </div>
            <div class="relative flex flex-col justify-center items-center">
              <el-progress
                color="rgba(95,213,236,1)"
                text-color="#fff"
                class="mt-5px"
                :width="60"
                type="dashboard"
                :percentage="item.percentage"
              ></el-progress>
              <div class="text-12px withe07 scale-90 absolute rateText">设备在线率</div>
            </div>
            <div class="onLine flex justify-between items-center mt-10px">
              <div class="flex justify-start items-center">
                <div class="onlineCircle"></div>
                <span class="text-12px withe07 ml-5px">在线</span>
              </div>
              <div class="text-12px">{{ item.onlineNum }}</div>
            </div>
            <div class="offLine flex justify-between items-center mt-5px">
              <div class="flex justify-start items-center">
                <div class="offlineCircle"></div>
                <span class="text-12px withe07 ml-5px">离线</span>
              </div>
              <div class="text-12px">{{ item.offLineNum }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="leftCenter mt-10px w-full min-h-180px h-[calc(50%-134px)]">
      <CategoryTitle title="厂区报警趋势"></CategoryTitle>
      <div class="chartBox relative mt-10px">
        <DiyButtonGroup
          @button-click="buttonClick"
          :value="btnValue"
          :list="['日', '月']"
          class="absolute right-0 -top-15px z-999"
        ></DiyButtonGroup>
        <v-chart
          :options="alarmTrend"
          autoresize
          class="w-full h-full alarmTrend"
          ref="alarmTrend"
        ></v-chart>
      </div>
    </div>
    <div class="w-full min-h-125px h-[calc(50%-164px)]">
      <div class="relative w-full">
        <CategoryTitle title="监控轮播"></CategoryTitle>
        <span
          class="absolute right-0 top-0 text-white text-18px cursor-pointer"
          @click="viewDetail(deviceList[0])"
        >
          <i class="el-icon-arrow-right transform !translate-x-12px"></i
          ><i class="el-icon-arrow-right"></i
        ></span>
      </div>
      <div
        class=" h-[calc(100%-18px)] w-full flex flex-wrap content-start justify-start overflow-hidden"
      >
        <videoWall
          v-if="cameraCodes.length"
          :cameraCodes="cameraCodes"
          :typeNum="typeNum"
          class="w-full h-full"
          ref="videoWall"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { WisdomSecurityApi, WorkTicketApi } from '@wiz-api/huizhou2'
import { IOTDeviceApi } from '@wiz-api/iot-device-management'
import { includes, get, isNil, map, isEmpty, find, cloneDeep } from 'lodash'
import DeviceList from '../../assets/js/componentMethods/deviceList'

const iotDeviceApi = new IOTDeviceApi()
const workTicketApi = new WorkTicketApi()

const wisdomSecurityApi = new WisdomSecurityApi()

const CategoryTitle = () => {
  return import('@/components/cockpit/CategoryTitle')
}
const DiyButtonGroup = () => {
  return import('../../../cockpit-huizhou/components/global/DiyButtonGroup')
}

const videoWall = () => {
  return import('./components/video/YSPlayer/videoWallNew')
}

export default {
  name: 'DigitalEngineering',
  components: {
    CategoryTitle,
    DiyButtonGroup,
    videoWall,
  },
  props: {
    player: {
      type: Object,
      defalut: null,
    },
    mode: {
      type: String,
      default: 'visualization',
    },
    labelList: {
      type: Array,
      default: () => { return [] },
    },
  },
  data() {
    return {
      deviceList: [
        {
          name: '监控设备',
          totalNum: 0,
          currenAreaNum: 0,
          url: require('../../assets/images/smartSecurity/监控设备.png'),
          code: 'scameraList',
          codeName: '摄像头列表',
        },
        {
          name: '道闸设备',
          totalNum: 0,
          currenAreaNum: 0,
          url: require('../../assets/images/smartSecurity/barriers-equipment.png'),
          code: 'accessControlGateList',
          codeName: '道闸设备',
        },
        {
          name: '门禁设备',
          totalNum: 0,
          currenAreaNum: 0,
          url: require('../../assets/images/smartSecurity/门禁道闸.png'),
          code: 'accessDoorControlGateList',
          codeName: '门禁设备',
        },
        {
          name: '环境监测',
          totalNum: 0,
          currenAreaNum: 0,
          url: require('../../assets/images/smartSecurity/环境监测.png'),
          code: 'environmentalMonitoringList',
          codeName: '环境列表',
        },
      ],
      rateList: [
        {
          name: '监控设备',
          totalNum: 0,
          onlineNum: 0,
          offLineNum: 0,
          percentage: 0,
        },
        {
          name: '门禁设备',
          totalNum: 0,
          onlineNum: 0,
          offLineNum: 0,
          percentage: 0,
        },
        {
          name: '道闸设备',
          totalNum: 0,
          onlineNum: 0,
          offLineNum: 0,
          percentage: 0,
        },
      ],
      tab: 'day',
      alarmTrend: {
        color: ['#6691f7', '#88cbd5'],
        tooltip: {
          trigger: 'axis',
        },
        grid: {
          top: 25,
          left: 30,
          bottom: 40,
          right: 0,
        },
        legend: {
          show: true,
          top: 0,
          icon: 'circle',
          itemWidth: 8,
          itemHeight: 8,
          textStyle: {
            color: '#fff',
            fontSize: 12,
          },
        },
        dataZoom: {
          show: false,
          startValue: 0,
          endValue: 8,
          maxValueSpan: 8,
          height: 15,
          bottom: '5',
          textStyle: {
            color: 'rgba(255,255,255,0.6)',
          },
          borderColor: 'transparent',
          backgroundColor: '#062830',
          fillerColor: '#185663',
        },
        xAxis: {
          type: 'category',
          data: [],
          axisTick: {
            show: false,
          },
          axisLabel: {
            color: '#fff9',
          },
          splitLine: {
            lineStyle: {
              color: '#d9d9d9',
            },
          },
          axisLine: {
            lineStyle: {
              color: '#ffffff33',
            },
          },
        },
        yAxis: {
          type: 'value',
          nameTextStyle: {
            color: 'rgba(255, 255, 255, 0.6)',
            fontSize: 12,
            padding: [0, 30, 0, 0],
          },
          minInterval: 1,
          nameLocation: 'start',
          splitNumber: 4,
          axisLabel: {
            color: '#fff9',
          },
          axisLine: {
            show: false,
          },
          splitLine: {
            lineStyle: {
              color: 'rgba(255,255,255,0.05)',
            },
          },
        },
        series: [
          {
            name: '报警数量',
            data: [],
            type: 'line',
            symbol: 'circle',
            symbolSize: 8,
          },
          {
            name: '处理数量',
            data: [],
            type: 'line',
            symbol: 'circle',
            symbolSize: 8,
          },
        ],
      },
      btnValue: '日',
      videoList: [],
      cameraCodes: [],
      // 摄像头报警展示的定时器
      alarmTimer: null,
      typeNum: 2,
      cameraTouringTimeBar: null,
      alarmData: {
        todayData: {
          xAxis: [],
          series: [],
          dataZoom: false,
        },
        monthData: {
          xAxis: [],
          series: [],
          dataZoom: false,
        },
      },
      cameraMarker: null,
      alarmCameraList: [],
      isCreateMarker: false,
      isUpdateMarker: false,
      // 获取报警趋势的定时器
      getAlarmTimer: null,
    }
  },
  watch: {
    btnValue: {
      immediate: true,
      handler() {
        this.toogleTypeHandler()
      },
    },
    alarmData: {
      deep: true,
      handler() {
        this.toogleTypeHandler()
      },
    },
    mode(value) {
      if (!this.cameraMarker) return
      // 如果切回可视化模式并且有报警的摄像头
      if (value === 'visualization' && !isEmpty(this.alarmCameraList) && !this.isCreateMarker) {
        // 如果之前是更新的，那现在就使用创建模式
        this.isUpdateMarker = false
        this.isCreateMarker = true
        this.cameraMarker?.create(this.player)
        // 如果切到驾驶舱模式并且之前创建过图标，则销毁图标
      } else if (value === 'cockpit' && (this.isCreateMarker || this.isUpdateMarker)) {
        this.isCreateMarker = false
        this.cameraMarker?.destroy()
      }
    },
  },
  async created() {
    await this.getVideoList()
    this.getSecurityDeviceStatsReport()
    this.getFactoryAlarmTrendReport()
    this.getAlarmCarouselList()
    this.getAlarmData()
    this.getAlarmTimer = setInterval(() => {
      this.getAlarmData()
    }, 1000 * 60 * 10)
  },
  methods: {
    async getSecurityDeviceStatsReport() {
      const [err, res] = await wisdomSecurityApi.getSecurityDeviceStatsReport()
      if (!err) {
        if (res && res.length) {
          res.forEach((item) => {
            this.deviceList.forEach((it) => {
              if (includes(it.name, item.deviceName)) {
                it.totalNum = item.totalCount
                it.currenAreaNum = item.onLineCount
              }
            })
          })
          res.forEach((item) => {
            this.rateList.forEach((it) => {
              if (includes(it.name, item.deviceName)) {
                it.totalNum = item.totalCount
                it.onlineNum = item.onLineCount
                it.offLineNum = item.offlineCount
                it.percentage = item.percentage
              }
            })
          })
        }
      }
    },
    async getVideoList() {
      const [err, data] = await iotDeviceApi.getDeviceWithDetailPageList({
        deviceTypeCode: 'Camera',
        status: 1,
        skipCount: 0,
        maxResultCount: 10000,
      })
      if (!err && data) {
        this.videoList = cloneDeep(data.items)
        this.cameraCodes = cloneDeep(data.items)
      }
    },
    async getFactoryAlarmTrendReport() {
      const [err, res] = await wisdomSecurityApi.getFactoryAlarmTrendReport({
        time: this.btnValue === '日' ? 1 : 2,
      })
    },
    buttonClick(val) {
      this.btnValue = val
      this.getFactoryAlarmTrendReport()
    },
    async getAlarmCarouselList() {
      const [err, res] = await wisdomSecurityApi.getAlarmCarouselList()
    },
    // 获取报警摄像头
    async getAlarmData() {
      const [err, res] = await workTicketApi.getAlarmStatics()
      console.log(err, res, '=========')
      if (!err && !isNil(res)) {
        this.alarmData.todayData.xAxis = map(res.toDayAlarms, (item) => { return moment(item.date || item._date).format('HH:mm') })
        this.alarmData.todayData.series = [
          map(res.toDayAlarms, 'alarmCount'),
          map(res.toDayAlarms, 'proccessed'),
        ]
        this.alarmData.todayData.dataZoom = res.toDayAlarms?.length >= 8
        this.alarmData.monthData.xAxis = map(res.monthAlarms, (item) => { return moment(item.date || item._date).format('MM-DD') })
        this.alarmData.monthData.series = [
          map(res.monthAlarms, 'alarmCount'),
          map(res.toDayAlarms, 'proccessed'),
        ]
        this.alarmData.monthData.dataZoom = res.monthAlarms?.length >= 8
        // 绘制报警摄像头
        this.alarmCameraList = res.deviceDetails || []
        // 如果有报警的摄像头，则绘制标签
        // 有两种模式
        if (!isEmpty(this.alarmCameraList)) {
          this.typeNum = 1
          this.cameraCodes = cloneDeep(this.alarmCameraList)
          if (!isNil(this.alarmTimer)) clearTimeout(this.alarmTimer)
          this.alarmTimer = setTimeout(() => {
            this.cameraCodes = cloneDeep(this.videoList)
            this.typeNum = 2
          }, 1000 * 60 * 2)
          console.log(123, this.alarmCameraList)
          // 一上来也是需要创建一个设备图标实例，用于切换驾驶舱三维可视化模式使用
          this.cameraMarker = new DeviceList(
            { name: '摄像头', value: 'camera' },
            this.alarmCameraList
          )
          const label = find(this.labelList, ['code', 'CameraList'])
          // 如果已经勾选了监控标签，则更新
          if (label && label.checked) {
            const updateEvent = new CustomEvent('updateCamera', {
              detail: {
                isAlarm: true,
                alarmList: this.alarmCameraList,
              },
            })
            window.dispatchEvent(updateEvent)
            this.isUpdateMarker = true
          } else {
            // 如果之前没有勾选监控标签，则直接创建报警的图标
            this.cameraMarker?.create(this.player)
            this.isCreateMarker = true
          }
        }
      }
    },
    viewDetail(row) {
      if (!row.code) {
        return
      }
      this.$emit('transferEvent', {
        toCom: { code: row.code, origin: 'SmartSecurityPage', name: row.codeName },
        type: 'mainComponent',
        props: {
          ...row,
        },
      })
    },
    viewDetail1() {
      this.$emit('transferEvent', {
        toCom: { code: 'disposalCard', origin: 'SmartSecurityPage', name: '预制处置卡' },
        type: 'mainComponent',
        props: {},
      })
    },
    toogleTypeHandler() {
      let objName = ''
      switch (this.btnValue) {
        case '日':
          objName = 'todayData'
          break
        case '月':
          objName = 'monthData'
          break
        default:
          break
      }
      if (includes(['todayData', 'monthData'], objName)) {
        this.alarmTrend.xAxis.data = get(this, `alarmData.${objName}.xAxis`)
        this.alarmTrend.series[0].data = get(this, `alarmData.${objName}.series[0]`)
        this.alarmTrend.series[1].data = get(this, `alarmData.${objName}.series[1]`)
        this.alarmTrend.dataZoom.show = get(this, `alarmData.${objName}.dataZoom`)
      }
    },
  },
  beforeDestroy() {
    if (!isNil(this.getAlarmTimer)) clearInterval(this.getAlarmTimer)
    if (!isNil(this.alarmTimer)) clearTimeout(this.alarmTimer)
    if (isEmpty(this.alarmCameraList)) return
    if (this.isUpdateMarker) {
      const updateEvent = new CustomEvent('updateCamera', {
        detail: {
          isAlarm: false,
        },
      })
      window.dispatchEvent(updateEvent)
    } else if (this.isCreateMarker && this.cameraMarker) {
      this.cameraMarker?.destroy()
    }
  },
}
</script>
<style lang="scss" scoped>
.left {
  .statisticsNum,
  .statisticsRate {
    color: #ffffff;
    text-shadow: 0px 0px 13.88px 0px #2f7eff72, 0px 3.08px 6.17px 0px #1da0e999;
    font-family: PangMenZhengDao;
    font-weight: regular;
    font-size: 14px;
    line-height: normal;
    letter-spacing: 0px;
    text-align: center;
  }
  .statisticsRate {
    .reteItem {
      .one {
        border-radius: 0.9px 0.9px 0px 0px;
        background: #53e0ff66;
        height: 27px;
        line-height: 27px;
      }
      .two {
        border-radius: 0.9px 0.9px 0px 0px;
        background: #59d4a08e;
        height: 27px;
        line-height: 27px;
      }
      .three {
        border-radius: 0.9px 0.9px 0px 0px;
        background: #c3c06c7f;
        height: 27px;
        line-height: 27px;
      }
      .bottomBox {
        border: 1px dotted rgba(255, 255, 255, 0.2);
        padding: 5px;
        .totalBox {
          border-radius: 0.9px;
          background: rgba(40, 163, 202, 0.1);
        }
        .withe07 {
          color: rgba(255, 255, 255, 0.7);
        }
        .onlineCircle {
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background-color: rgba(13, 165, 55, 1);
        }
        .offlineCircle {
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background-color: rgba(148, 168, 217, 1);
        }
        .rateText {
          bottom: -5px;
          transform: scale(0.8);
        }
      }
    }
  }
  .leftCenter {
    .chartBox {
      height: calc(100% - 40px);
      .alarmTrend {
        width: 100%;
        height: 100%;
      }
    }
  }
  .tableBox {
    height: calc(100% - 40px);
    color: rgba(255, 255, 255, 0.8);
    font-family: HarmonyOS Sans SC;
    font-size: 12px;
    text-align: center;
    .activeBg {
      background-image: url('../../assets/images/smartSecurity/tableSelectedBg.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .tableHeader {
      height: 36px;
      border-radius: 1px;
      background: linear-gradient(0deg, rgba(0, 116, 141, 0.43) 0%, rgba(0, 116, 153, 0) 100%),
        linear-gradient(0deg, rgba(135, 233, 255, 1) 0%, rgba(98, 156, 168, 0) 100%);
      align-items: center;
      justify-content: space-between;
    }
    .w-30 {
      width: 30%;
    }
    .w-25 {
      width: 25%;
    }
    .w-20 {
      width: 20%;
    }
    .tableBody {
      height: 88%;
      overflow: auto;
      .tableTr {
        height: 40px;
        align-items: center;
        justify-content: space-between;
        border-radius: 1px;
        // background: rgba(255, 255, 255, 0.04);
        // border: 1px solid rgba(255, 255, 255, 0.1);
        margin-bottom: 2px;
        cursor: pointer;
      }
    }
  }
}
.right {
  // background-image: url('../../image/environmentalSafety/frameBg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding: 30px 21px 16px 30px;
}
</style>
